enum Breakpoints {
  sm = 600,
  md = 900,
  lg = 1080,
  xl = 1536,
}

export default Breakpoints;
